<script>
	export let color = "#00ffcc";
	export let disabled = false;
	let inputPick;
</script>

<div class="--color-picker" class:disabled>
	<div class="--cp-out" style:background={color}>
		&nbsp;
	</div>
	<input type="color" bind:value={color} bind:this={inputPick} />
</div>

<style>
	div.--color-picker {
		position: relative;
		min-width: 6rem;
		min-height: 3rem;
		border: 2px solid #333;
		border-radius: 2px;
		cursor: pointer;
	}

	div.--color-picker.disabled {
		opacity: 0.5;
		pointer-events: none;
	}
	
	div.--cp-out {
		position: absolute;
		z-index: 1;
		inset: 2px;
		border-radius: 2px;
	}
	
	div.--color-picker:hover,
	div.--color-picker:focus-within {
		border-style: dashed;
	}
	
	input[type="color"] {
		position: absolute;
		z-index: 2;
		padding: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
	}
</style>